import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from '@api/services.service';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-services-tracking',
  templateUrl: './services-tracking.component.html',
  styleUrls: ['./services-tracking.component.scss']
})
export class ServicesTrackingComponent implements OnInit {

  public destroy$ = new Subject<void>();
  trackingId: number;
  trackingService;
  steps;
  baseUrl = environment.baseUrl;
  constructor(
    private servicesService: ServicesService,
    private activeRoute: ActivatedRoute,
    ) { }

  ngOnInit(): void {
    this.getTrackingId();
    this.getTracking();
  }
  getTrackingId() {
    this.trackingId = this.activeRoute.snapshot.params['tracking-id'];
  }
  getTracking() {
    this.servicesService.getTrackingService(this.trackingId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.trackingService = res;
        this.steps = this.trackingService?.serviceStates;
      }
    )
  }
  getImageUrl(url: string) {
    if (url) {
      return `${this.baseUrl}/${url}`;
    }
    if (!url) {
      return 'assets/img/no-image.jpg';
    }
  }
}
